/* eslint eslint-comments/no-use: off */

import type {SharedBulkActionsItemPickerProps} from '@github-ui/item-picker-base/ItemPicker'
import type {
  IssueTypePickerBaseProps,
  IssueTypePickerIssueType as IssueTypePickerBaseIssueType,
} from '@github-ui/item-picker-issue-type'
import {IssueTypePicker as IssueTypePickerTsq} from '@github-ui/item-picker-issue-type-tsq'

import {BulkIssueIssueTypePickerTsqWithRelayWrapper} from './BulkIssueIssueTypePickerTsqWithRelayWrapper'

export const UNSET_ID = 'UNSET'

// We want to keep compat with the existing type
// eslint-disable-next-line relay/no-future-added-value
type IssueFieldDataType = 'DATE' | 'NUMBER' | 'SINGLE_SELECT' | 'TEXT' | '%future added value'

type BaseIssueField = {
  readonly dataType: IssueFieldDataType
  readonly id: string
  readonly name: string
}

type PinnedFieldsType =
  | ReadonlyArray<
      | (BaseIssueField & {readonly __typename: 'IssueFieldDate'})
      | (BaseIssueField & {readonly __typename: 'IssueFieldNumber'})
      | (BaseIssueField & {readonly __typename: 'IssueFieldSingleSelect'})
      | (BaseIssueField & {readonly __typename: 'IssueFieldText'})
      | {
          // This will never be '%other', but we need some
          // value in case none of the concrete values match.
          readonly __typename: '%other'
        }
    >
  | null
  | undefined

export type IssueTypePickerIssueType = IssueTypePickerBaseIssueType & {
  pinnedFields?: PinnedFieldsType
}

export type IssueTypePickerProps = IssueTypePickerBaseProps & {
  owner: string
}

export function IssueTypePicker(props: IssueTypePickerProps) {
  return <IssueTypePickerTsq {...props} />
}

type BulkIssueIssueTypePickerProps = Omit<IssueTypePickerProps, 'onSelectionChange'> & SharedBulkActionsItemPickerProps

export function BulkIssueIssueTypePicker(props: BulkIssueIssueTypePickerProps) {
  return <BulkIssueIssueTypePickerTsqWithRelayWrapper {...props} />
}

try{ IssueTypePicker.displayName ||= 'IssueTypePicker' } catch {}
try{ BulkIssueIssueTypePicker.displayName ||= 'BulkIssueIssueTypePicker' } catch {}